var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16992 7.44L11.9999 12.55L20.7699 7.47",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.61V12.54",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92965 2.48L4.58965 5.44C3.37965 6.11 2.38965 7.79 2.38965 9.17V14.82C2.38965 16.2 3.37965 17.88 4.58965 18.55L9.92965 21.52C11.0696 22.15 12.9396 22.15 14.0796 21.52L19.4196 18.55C20.6296 17.88 21.6196 16.2 21.6196 14.82V9.17C21.6196 7.79 20.6296 6.11 19.4196 5.44L14.0796 2.47C12.9296 1.84 11.0696 1.84 9.92965 2.48Z",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectInactive);
export default __webpack_public_path__ + "static/media/project_inactive.55209d357707b9c152c7215fef018576.svg";
export { ForwardRef as ReactComponent };